import React from 'react';

import { routes } from '@aline/routes';
import { Helmet } from 'react-helmet';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ContentWrapper } from 'src/components';
import { createRelativeRouter } from 'src/helpers/router-helpers';
import { makeStyles } from 'tss-react/mui';

import { Statistics } from './components/Statistics';
import {
  WorkflowInbox,
  workflowsInboxScrollableTargetId,
} from './components/workflows/WorkflowsInbox';

const useStyles = makeStyles()(theme => ({
  dashboardBody: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  mainContent: {
    backgroundColor: theme.palette.common.white,
    flex: 1,
    minHeight: 0, // Required for flex children to shrink below content size
    overflow: 'auto',
  },
}));

const { toRelativePath: toRelativeDashboardPath } = createRelativeRouter(routes.DashboardIndex, {
  nestedRoutes: true,
});

export function Dashboard(): JSX.Element {
  const { classes } = useStyles();

  return (
    <>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <div className={classes.mainContent} id={workflowsInboxScrollableTargetId}>
        <Routes>
          <Route element={<UserInbox />} path={toRelativeDashboardPath(routes.DashboardIndex)} />
          <Route
            element={<Navigate replace to={routes.DashboardIndex} />}
            path={toRelativeDashboardPath(routes.DashboardInbox)}
          />
        </Routes>
      </div>
    </>
  );
}

export function UserInbox(): JSX.Element {
  const { classes } = useStyles();

  return (
    <ContentWrapper>
      <div className={classes.dashboardBody}>
        <WorkflowInbox />
        <Statistics />
      </div>
    </ContentWrapper>
  );
}
